import React from 'react'
import { useLocation } from 'react-router-dom'

import AnalyticsModule from '../../../widgets/analytics'

const Analytics = ({ client, userData }) => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const orgId = queryParams.get('org_id')

  // the org page emulates the org owner's view (webapp parity): member
  // dropdown, Team tab, org-wide aggregation
  const viewedUser = {
    id: orgId,
    email: userData?.email,
    name: userData?.name,
    user_type: 'organization',
    user_role: 'owner',
    org_id: orgId
  }

  return (
    <div>
      <AnalyticsModule
        client={client}
        viewedUser={viewedUser}
      />
    </div>
  )
}

export default Analytics
